// extracted by mini-css-extract-plugin
export var settingsList = "_3k-0";
export var settingsRow = "_3k-1";
export var warningDot = "_3k-2";